import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getCurrencyRates } from '../currencyService'

export const useCurrencyRates = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.CURRENCY_RATES],
    queryFn: () => getCurrencyRates(),
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })
}
